module.exports = __webpack_public_path__ + "static/media/P200-Tip.e6854ceb.svg";